export default __webpack_public_path__ + "static/media/report10.d0d04c5d.png";